import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/app.css';
//window.$ = window.jQuery = require('jquery');

import vueSmoothScroll from 'vue-smooth-scroll'
Vue.use(vueSmoothScroll)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

window.axios = require('axios');

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js